import _possibleConstructorReturn from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { constructFrom } from "../../constructFrom.js";
import { transpose } from "../../transpose.js";
var TIMEZONE_UNIT_PRIORITY = 10;
export var Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck(this, Setter);

    _defineProperty(this, "subPriority", 0);
  }

  return _createClass(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);
}();
export var ValueSetter = /*#__PURE__*/function (_Setter2) {
  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this2;

    _classCallCheck(this, ValueSetter);

    _this2 = _callSuper(this, ValueSetter);
    _this2.value = value;
    _this2.validateValue = validateValue;
    _this2.setValue = setValue;
    _this2.priority = priority;

    if (subPriority) {
      _this2.subPriority = subPriority;
    }

    return _this2;
  }

  _inherits(ValueSetter, _Setter2);

  return _createClass(ValueSetter, [{
    key: "validate",
    value: function validate(date, options) {
      return this.validateValue(date, this.value, options);
    }
  }, {
    key: "set",
    value: function set(date, flags, options) {
      return this.setValue(date, flags, this.value, options);
    }
  }]);
}(Setter);
export var DateTimezoneSetter = /*#__PURE__*/function (_Setter3) {
  function DateTimezoneSetter(context, reference) {
    var _this3;

    _classCallCheck(this, DateTimezoneSetter);

    _this3 = _callSuper(this, DateTimezoneSetter);

    _defineProperty(_this3, "priority", TIMEZONE_UNIT_PRIORITY);

    _defineProperty(_this3, "subPriority", -1);

    _this3.context = context || function (date) {
      return constructFrom(reference, date);
    };

    return _this3;
  }

  _inherits(DateTimezoneSetter, _Setter3);

  return _createClass(DateTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) return date;
      return constructFrom(date, transpose(date, this.context));
    }
  }]);
}(Setter);